import { removeSpace, removeUnderline } from 'utils/masks';

const AddressInputSchema = {
  streetAddress: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  city: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  state: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  zip: [{
    rule: 'required',
    error: 'The input field is required',
    isValid: (input) => {
      if (!input || removeSpace(input).length === 0) {
        return 'The input field is required';
      } else if (removeUnderline(input).length !== 5) {
        return 'Invalid zipcode';
      }
      return true;
    },
  }],
}

export default AddressInputSchema;
